import { inspect } from "util";

/**
 * Like `JSON.stringify`, but catching exceptions thrown when the object has circular references.
 */
export function safeStringify(o: unknown) {
	try {
		return JSON.stringify(o);
	} catch (e) {
		return inspect(o);
	}
}
